import { forwardRef } from "react";
import { Dropdown } from "primereact/dropdown";
import {
    DashlyFilterDropdown,
    type DashlyFilterDropdownProps,
} from "../DashlyFilterDropdown/DashlyFilterDropdown";

export type FilterNativeSelectProps = DashlyFilterDropdownProps;

/**
 * @deprecated Use {@link DashlyFilterDropdown}. Former native &lt;select&gt;; now a Prime/Dashly filter dropdown.
 */
const FilterNativeSelect = forwardRef<Dropdown, FilterNativeSelectProps>(function FilterNativeSelect(props, ref) {
    return <DashlyFilterDropdown ref={ref} {...props} />;
});

FilterNativeSelect.displayName = "FilterNativeSelect";

export { FilterNativeSelect };
